import { render, staticRenderFns } from "./ProfileDebug.vue?vue&type=template&id=09b33e25&scoped=true&"
import script from "./ProfileDebug.vue?vue&type=script&lang=ts&"
export * from "./ProfileDebug.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileDebug.vue?vue&type=style&index=0&id=09b33e25&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b33e25",
  null
  
)

export default component.exports